import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useFKspjdListQuery } from '../../../store/DianShangYeWuApi'
import RuleCostAdd from './RuleCostAdd'
import RuleCostEdit from './RuleCostEdit'   
import RuleCostCopy from './RuleCostCopy'
function RuleCostList(props) {
    const [list, setList] = useState([])
    const {data, isSuccess} = useFKspjdListQuery({ddzc_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
        }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'ddzc_spjd_id',
            key: 'ddzc_spjd_id',
            render: (text, record) => <RuleCostCopy 
                                        ddzc_spjd_id={record.ddzc_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '付款单规则名称',
            dataIndex: 'ddzc_spjd_content',
            key: 'ddzc_spjd_content',
            render: (text, record) => <RuleCostEdit 
                                        ddzc_spjd_content={text} 
                                        ddzc_spjd_id={record.ddzc_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },

        {
            title: '付款单部门',
            dataIndex: 'ddzc_spjd_bm_name',
            key: 'ddzc_spjd_bm_name',
        },
        {
            title: '付款单往来类型',
            dataIndex: 'ddzc_spjd_zflx',
            key: 'ddzc_spjd_zflx',
        },
        {
            title: '付款单最小金额',
            dataIndex: 'ddzc_spjd_amount_min',
            key: 'ddzc_spjd_amount_min',
        },
        {
            title: '付款单最大金额',
            dataIndex: 'ddzc_spjd_amount_max',
            key: 'ddzc_spjd_amount_max',
        },
        {
            title: '新增记录',
            dataIndex: 'ddzc_spjd_uname',
            key: 'ddzc_spjd_uname',
            render: (text, record) => <span>{record.ddzc_spjd_uname} {record.ddzc_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
                <RuleCostAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='ddzc_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleCostList